<!--<div class="larger-card" [ngClass]="{'pinned':item.pinnedTime}"-->
<div class="larger-card" tabindex="0" (keypress)="enterItemByKeyboard($event)"
    [ngClass]="{'larger-pinned':item.pinnedTime}" (click)="showDetails()">

    <div class="larger-image">
        <ig-image [imageUrl]="item.cover?.source" [class.promotion]="item.isPromotionImage"
            [alt]="item.title||item.name"></ig-image>
        <div style="position: absolute;top:10%;left:0;width: 100%">
            <div *ngIf="!item.isPromotionImage" class="ig-title" style="flex:4">
                <span>{{item.title||item.name}}</span>
            </div>
            <div class="choice" *ngIf="item.isChoice" matTooltip="Editor's choice">
                <mat-icon>favorite</mat-icon>
            </div>
            <div *ngIf="item.categoryList&&item.categoryList.length" class="place-category">
                <span>{{toReadable(item.categoryList[0])}}</span>
            </div>
        </div>

    </div>

    <div class="detail-btn-wrap" role="button">
        details
    </div>

    <!--<div class="align-center" *ngIf="!item.isPromotionImage">-->
    <!--<div class="long-time flex">-->
    <!--<div *ngIf="item.startTime" class="time">-->
    <!--<mat-icon>date_range</mat-icon>-->
    <!--<span *ngIf="item.eventTimes&&item.eventTimes.length>1">Multiple Dates Event - See Details</span>-->
    <!--<span *ngIf="item.eventTimes&&item.eventTimes.length<=1" [class.small-time-text]="eventTimeText.length>41">{{eventTimeText}}</span>-->
    <!--</div>-->

    <!--<div *ngIf="!item.startTime" category class="time" [matTooltip]="item.category">-->
    <!--<mat-icon>list</mat-icon>-->
    <!--<span>{{placeCategory}}</span>-->
    <!--</div>-->

    <!--<div class="detail-btn-wrap">-->
    <!--details-->
    <!--</div>-->
    <!--</div>-->

    <!--</div>-->

</div>


// WEBPACK FOOTER //
// D:/Work/Development/vsts_build/_work/2/s/web/src/components/visitor/calendar/larger.card/visitor.larger.card.component.html